import React from "react";
import Unit from "./components/Unit/Unit.component";
import "./App.css";

const App = () => (
	<div className="app">
		<Unit />
	</div>
);

export default App;
